import { render } from "./PartnerReservedScheduleModal.vue?vue&type=template&id=464bb085"
import script from "./PartnerReservedScheduleModal.vue?vue&type=script&lang=js"
export * from "./PartnerReservedScheduleModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/pslcal/meruhensya.com/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__